import React, { useEffect, useState, useContext } from 'react';
import { Container } from 'react-bootstrap';
import { AuthenticationContext } from './App';
import Navbar from 'react-bootstrap/Navbar';

const Login = (props) => {
  const keycloak = useContext(AuthenticationContext);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const MainContentLargeScreen = () => {
    return (
      <main role="main" className="p-0 d-md-block d-none">
        <div className="container-fluid p-0 pl-5">
          <div className="row mr-0">
            <div className="col my-auto">
              <div className="row">
                <div className="col">
                  <h1>Welcome to the Snow Avalanche and Weather System</h1>
                  <p>To access the system please authenticate with one of the following options:</p>
                </div>
              </div>
              <div className="row">
                <div className="col w-100">
                  <div className="row">
                    <div className="col-xl-4 col-lg-5 col-6">
                      <a
                        type="button"
                        className="btn btn-block btn-primary my-2"
                        style={{ color: '#ffffff', textDecoration: 'none' }}
                        onClick={() => keycloak.login({ idpHint: 'idir', redirectUri: window.location })}
                      >
                        IDIR
                      </a>
                    </div>
                    <div className="col-xl-4 col-lg-5 col-6">
                      <a
                        type="button"
                        className="btn btn-block btn-primary my-2"
                        style={{ color: '#ffffff', textDecoration: 'none' }}
                        onClick={() => keycloak.login({ idpHint: 'bceidbusiness', redirectUri: window.location })}
                      >
                        BCeID
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">&nbsp;</div>
              <div className="row">
                <div className="col my-auto">
                  <p className="small p-2">
                    Having issues logging in? Please contact support at{' '}
                    <a href="mailto:awpit@gov.bc.ca">awpit@gov.bc.ca</a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col pr-0">
              <img className="card-img-top" src="/assets/images/mountains-desktop.jpg" alt="Card image cap" />
            </div>
          </div>
        </div>
      </main>
    );
  };

  const MainContentSmallScreen = () => {
    return (
      <main role="main" className="p-0 d-block d-md-none">
        <div className="container-fluid p-0">
          <div className="row mr-0">
            <div className="col pr-0">
              <img className="card-img-top" src="/assets/images/mountains-mobile.jpg" alt="Card image cap" />
            </div>
          </div>
          <div className="row mr-0">
            <div className="col my-auto">
              <div className="row">
                <div className="col">
                  <h2 className="p-3">Welcome to the Snow Avalanche and Weather System</h2>
                  <p className="pt-0 pr-3 pl-3 pb-0">
                    To access the system please authenticate with one of the following options:
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col w-100">
                  <div className="row">
                    <div className="col-2"></div>
                    <div className="col-4">
                      <a
                        type="button"
                        className="btn btn-block btn-primary my-2"
                        style={{ color: '#ffffff', textDecoration: 'none' }}
                        onClick={() => keycloak.login({ idpHint: 'idir', redirectUri: window.location.origin })}
                      >
                        IDIR
                      </a>
                    </div>
                    <div className="col-4">
                      <a
                        type="button"
                        className="btn btn-block btn-primary my-2"
                        style={{ color: '#ffffff', textDecoration: 'none' }}
                        onClick={() =>
                          keycloak.login({ idpHint: 'bceidbusiness', redirectUri: window.location.origin })
                        }
                      >
                        BCeID
                      </a>
                    </div>
                    <div className="col-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mr-0">&nbsp;</div>
          <div className="row mr-0">
            <div className="col my-auto">
              <p className="small p-2">
                Having issues logging in? Please contact support at <a href="mailto:awpit@gov.bc.ca">awpit@gov.bc.ca</a>
              </p>
            </div>
          </div>
        </div>
      </main>
    );
  };

  if (showContent)
    return (
      <>
        <header>
          <Navbar variant="light" bg="light" expand="lg" className="main-nav border-bottom">
            <Container className="justify-content-start">
              <Navbar.Brand href="https://www2.gov.bc.ca">
                <img
                  className="img-fluid d-none d-md-block"
                  src="/assets/images/bcid-logo-en.svg"
                  width="150"
                  height="39.67"
                  alt="B.C. Government Logo"
                />
                <img
                  className="img-fluid d-md-none"
                  src="/assets/images/bcid-symbol-rev.svg"
                  width="64"
                  height="44"
                  alt="B.C. Government Logo"
                />
              </Navbar.Brand>
              <Navbar.Brand href="/" className="header_title d-none d-md-inline-block">
                Snow Avalanche and Weather System
              </Navbar.Brand>
              <Navbar.Brand href="/" className="header_title d-md-none">
                SAWS X
              </Navbar.Brand>
            </Container>
          </Navbar>
        </header>
        <MainContentLargeScreen />
        <MainContentSmallScreen />
        <footer className="footer">
          <nav className="navbar navbar-expand-lg navbar-dark">
            <div className="container">
              <div className="row h-100">
                <div className="col">&nbsp;</div>
              </div>
            </div>
          </nav>
        </footer>
      </>
    );

  return <></>;
};

export default Login;
